"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _MaskedInput = _interopRequireDefault(require("../MaskedInput"));

// Idk why, but it works if we declare a variable with mask.
// Passing mask directly to MaskedInput's mask property causes problem where it does not delete dash.
var MASK = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_MaskedInput["default"], (0, _extends2["default"])({}, props, {
    mask: MASK
  }));
};

exports["default"] = _default;